import { Alert } from '@zealy/design-system';
import { useTranslations } from 'next-intl';

export const SecurityAlert = () => {
  const t = useTranslations('reviews.alerts.security');

  return <Alert title={t('title')} description={t('description')} variant="warning" />;
};
